"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessEnvTCell = exports.ProcessEnvTRow = exports.ProcessEnvTBody = exports.ProcessEnvTable = exports.ProcessEnvContainer = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.ProcessEnvContainer = styled_components_1.default.div ``;
exports.ProcessEnvTable = styled_components_1.default.table ``;
exports.ProcessEnvTBody = styled_components_1.default.tbody ``;
exports.ProcessEnvTRow = styled_components_1.default.tr ``;
exports.ProcessEnvTCell = styled_components_1.default.td `
  padding: 5px;
`;
